'use client';

import type { CustomPrefabs, ProductDetailSettings, ProductTagsSettings } from './prefabs-store';
import { prefabsStore } from './prefabs-store';

type Props = {
    prefabs?: CustomPrefabs;
    templatePrefabs?: CustomPrefabs | null;
    productDetail?: ProductDetailSettings | null;
    productTags?: ProductTagsSettings | null;
};

/** Initializes prefabs store with config from layout. Enables ModalService to use the same prefabs as the page. */
export const PrefabsConfigInitializer = ({
    prefabs = {},
    templatePrefabs = null,
    productDetail = null,
    productTags = null,
}: Props) => {
    prefabsStore.setPrefabs(prefabs);
    prefabsStore.setTemplatePrefabs(templatePrefabs);
    prefabsStore.setProductDetail(productDetail);
    prefabsStore.setProductTags(productTags);
    return null;
};
